import { normalizeStatusList } from './../shared/utils';

export const buildsV2QueryParams = ({
  organizationId,
  ownership = {},
  statusList,
  cloudType,
  userId,
  isOpenSource,
  username,
  user,
}) => {
  const defaultParams = {
    cloudType,
    limit: 50,
    org_id: organizationId,
    ...normalizeStatusList(statusList),
  };

  if (isOpenSource) {
    return {
      cloudType,
      limit: 50,
      username,
      ...normalizeStatusList(statusList),
    };
  }

  if (ownership.type === 'team') {
    return {
      ...defaultParams,
      team_id: ownership.name,
    };
  }

  if (ownership.type === 'user') {
    return {
      ...defaultParams,
      user_id: userId,
    };
  }

  if (!ownership.type && user?.user_id) {
    return {
      ...defaultParams,
      user_id: user.user_id,
    };
  }

  return defaultParams;
};
